import { createContext, useCallback, useContext, useRef, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Reemplazo de window.confirm con el estilo del PLM (el nativo no se muestra en algunos navegadores
// embebidos y no explica bien la acción). Uso: const confirmar = useConfirm();
//   if (!(await confirmar({ titulo, mensaje, accion: "Eliminar", peligro: true }))) return;
const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [opts, setOpts] = useState(null);
  const resolver = useRef(null);

  const confirmar = useCallback((o) => new Promise((resolve) => {
    resolver.current = resolve;
    setOpts(typeof o === "string" ? { mensaje: o } : o);
  }), []);

  const cerrar = (valor) => {
    resolver.current?.(valor);
    resolver.current = null;
    setOpts(null);
  };

  return (
    <ConfirmContext.Provider value={confirmar}>
      {children}
      <AlertDialog open={!!opts} onOpenChange={(abierto) => { if (!abierto) cerrar(false); }}>
        <AlertDialogContent data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{opts?.titulo || "¿Confirmas?"}</AlertDialogTitle>
            {opts?.mensaje && <AlertDialogDescription className="whitespace-pre-line">{opts.mensaje}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => cerrar(false)} data-testid="confirm-cancelar">{opts?.cancelar || "Cancelar"}</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => cerrar(true)}
              className={opts?.peligro ? "bg-red-600 hover:bg-red-700" : ""}
              data-testid="confirm-aceptar"
            >
              {opts?.accion || "Confirmar"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  return useContext(ConfirmContext);
}
